import { useContext, useEffect, useState } from "react";
import MyTable from "../elements/MyTable";
import axiosInstance from "../../services/axios-instance";
import { SKILLS } from "../../services/endpoints";
import { DataContext } from "../../context/data-provider";

const cellNames = {
    cellOne: "Person",
    cellTwo: "Technologies",
    cellTree: "E-mail",
    cellFour: "Role",
};

const List = () => {
    const [allUsersSkills, setAllUsersSkills] = useState([]);
    const [loading, setLoading] = useState(true);
    const { currentUser } = useContext(DataContext);

    const isUser = currentUser?.role_id === 2;

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await axiosInstance.get(SKILLS);
                const data = response.data;

                if (isUser) {
                    const filteredData = data.filter(
                        (item: { role_id: number }) =>
                            item.role_id !== 0 && item.role_id !== 1
                    );
                    setAllUsersSkills(filteredData);
                } else {
                    setAllUsersSkills(data);
                }

                setLoading(false);
            } catch (error) {
                console.error(error);
            }
        }
        fetchData();
    }, [currentUser.role_id, isUser]);

    const showRoleColumn = !isUser;

    if (loading || !currentUser) {
        return <div>Loading...</div>;
    }

    return (
        <MyTable
            data={allUsersSkills}
            cellNames={cellNames}
            showRoleColumn={showRoleColumn}
        />
    );
};

export default List;
